<mat-dialog-content class="modal-header"><h2 mat-dialog-title>OBJETIVO</h2></mat-dialog-content>

    <mat-dialog-content class="modal-body">
      <div class="content">
        <div class="form-horizontal">
          <div class="form-group">
            <label class="col-md-3 control-label">Objetivo:</label>
            <div class="col-md-9">
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Objetivo</mat-label>
                <textarea
                  matInput
                  placeholder="Objetivo"
                  rows="5"
                  [(ngModel)]="model.objetivo" 
                  name="objetivo" maxlength="2000" required
                ></textarea>
                <!-- 
                  [disabled]="modelPersona.idEstado === 2" -->
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="form-horizontal">
            <div class="form-group">
              <label class="col-md-3 control-label">Meta:</label>
              <div class="col-md-9">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Meta</mat-label>
                  <textarea
                    matInput
                    placeholder="Meta"
                    rows="5"
                    [(ngModel)]="model.meta" 
                    name="meta" maxlength="2000" required
                  ></textarea>
                  <!-- 
                    [disabled]="modelPersona.idEstado === 2" -->
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="form-horizontal">
            <div class="form-group">
              <label class="col-md-3 control-label">Indicador:</label>
              <div class="col-md-9">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Indicador</mat-label>
                  <textarea
                    matInput
                    placeholder="Indicador"
                    rows="5"
                    [(ngModel)]="model.indicador" 
                    name="indicador" maxlength="2000" required
                  ></textarea>
                  <!-- 
                    [disabled]="modelPersona.idEstado === 2" -->
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="form-horizontal">
            <div class="form-group">
              <label class="col-md-3 control-label">Presupuesto:</label>
              <div class="col-md-9">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Presupuesto</mat-label>
                  <textarea
                    matInput
                    placeholder="Presupuesto"
                    rows="5"
                    [(ngModel)]="model.presupuesto" 
                    name="presupuesto" maxlength="2000" required
                  ></textarea>
                  <!-- 
                    [disabled]="modelPersona.idEstado === 2" -->
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="form-horizontal">
            <div class="form-group">
              <label class="col-md-3 control-label">Recurso:</label>
              <div class="col-md-9">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Recurso</mat-label>
                  <textarea
                    matInput
                    placeholder="Recurso"
                    rows="5"
                    [(ngModel)]="model.recurso" 
                    name="recurso" maxlength="2000" required
                  ></textarea>
                  <!-- 
                    [disabled]="modelPersona.idEstado === 2" -->
                </mat-form-field>
              </div>
            </div>
          </div>
      </div>
    </mat-dialog-content>
    
    <mat-dialog-actions align="end" class="modal-actions">
      <!-- <button type="submit" class="btn btn-naranja" (click)="Save()"
      [disabled]="!esValido()" mat-button ><mat-icon>send</mat-icon> Guardar</button>  -->
      
      <button type="button" class="btn btn-naranja2" mat-button (click)="onNoClick()" ><mat-icon>exit_to_app</mat-icon> Salir</button>
    </mat-dialog-actions>
    